import { Button, Col, Form, Input, Row, Space, theme, Table, message, Popconfirm } from 'antd';
import React, { useEffect, useState } from 'react';
import LoadingBase from '../../components/LoadingBase';
import '../../css/listbook-page.css';
import ModalWarehouseInfo from './component/ModalWarehouseInfo';
import { getListBranches, warehouse_delete, warehouse_list, warehouses_create, warehouses_update } from '../../services/apis';
import { HeaderTableCus, TYPE_MODAL } from '../../constants/constants';
import { useSelector } from 'react-redux';
import { PlusOutlined, SearchOutlined } from '@ant-design/icons';

const ListWarehousePage = () => {
    const { token } = theme.useToken();
    const [form] = Form.useForm();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [itemSelected, setItemSelected] = useState();
    const [typeModal, setTypeModal] = useState();
    const [titleModal, setTitleModal] = useState('');
    const [lstBranches, setLstBranches] = useState([]);
    const userReducer = useSelector((state) => state.userReducer?.data);
    const columns = [
        {
            title: 'STT',
            key: 'STT',
            width: 80,
            align: 'center',
            render: (text, record, index) => index + 1,
        },
        {
            title: 'Tên kho',
            dataIndex: 'name',
            key: 'name',
            render: (text, record, index) => <a onClick={() => handleEditWarehouse(record)} style={{ paddingLeft: 12 }}>{text}</a>,
        },
        {
            title: 'Chi nhánh',
            dataIndex: 'branch_name',
            key: 'branch_name',
            align: 'center',
        },
        {
            title: 'Ngày tạo',
            dataIndex: 'created_at',
            key: 'created_at',
            align: 'center',
        },
        {
            title: 'Hành động',
            dataIndex: 'action',
            key: 'action',
            width: 120,
            align: 'center',
            render: (text, record) => (
                <Space size="middle">
                    <a onClick={() => handleEditWarehouse(record)} >Sửa</a>
                    <Popconfirm
                        title="Bạn có chắc chắn muốn xóa?"
                        onConfirm={() => handleDeleteWarehouse(record)}
                        okText="Xóa"
                        cancelText="Hủy"
                        placement="topRight"
                    >
                        <a style={{ color: 'red' }}>Xóa</a>
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    const formStyle = {
        maxWidth: 'none',
        background: 'white',
        borderRadius: token.borderRadiusLG,
        paddingLeft: 0,
        paddingRight: 0,
        marginBottom: 12,
    };

    const handleDeleteWarehouse = async (record) => {
        try {
            const params = {
                id: record?.id,
            }
            setLoading(true);
            const res = await warehouse_delete(params);
            setLoading(false);
            if (res && res.status === 1) {
                message.success('Xoá thành công');
                getDataWarehouses(true);
            }
            else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
            }
        } catch (error) {
            console.log('error', error);
            message.error('Có lỗi xảy ra, vui lòng thử lại');
        }
    }

    const getDataBranches = async () => {
        try {
            const params = {
                keyword: '',
            }
            const res = await getListBranches(params);
            if (res && res.status === 1) {
                setLstBranches([...res?.data?.data?.map(item => ({
                    ...item,
                    label: item.name,
                    value: item.id
                }))]);
            } else {
                setLstBranches([]);
            }
        } catch (error) {
            console.log('error', error);
        }
    }

    const handleEditWarehouse = (record) => {
        setItemSelected(record);
        setTypeModal(TYPE_MODAL.EDIT);
        setShowModal(true);
        setTitleModal('Sửa thông tin kho');
    }
    const handleAddWarehouse = () => {
        setTypeModal(TYPE_MODAL.ADD);
        setShowModal(true);
        setTitleModal('Thêm kho mới');
    }

    const getDataWarehouses = async (showLoading) => {
        try {
            const params = {
                keyword: form.getFieldValue('name') ?? '',
                status: 'active',
                currentPage: 1,
                limit: 100,
            }
            if (showLoading) setLoading(true);
            const res = await warehouse_list(params);
            if (showLoading) setLoading(false);
            if (res && res.status === 1) {
                setData([...res?.data?.items]);
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
                setData([]);
            }
        } catch (error) {
            setLoading(false);
            console.log('error', error);
        }


    }

    const onFinish = async (dataForm) => {
        getDataWarehouses(true);
    };
    const callApiAddWarehouse = async (data) => {
        try {
            const params = {
                ...data,
                created_by: userReducer?.user_info?.id
            }
            const res = await warehouses_create(params);
            setLoading(false);
            if (res && res.status === 1) {
                message.success('Thêm mới thành công');
                getDataWarehouses(true);
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
            }
        } catch (error) {
            console.log('error', error);
            setLoading(false);
            message.error('Có lỗi xảy ra, vui lòng thử lại');
        }
    }

    const callApiUpdateProduct = async (data) => {
        try {
            const params = {
                ...data,
                created_by: userReducer?.user_info?.id
            }
            setLoading(true);
            const res = await warehouses_update(params);
            setLoading(false);
            if (res && res.status === 1) {
                message.success('Cập nhật thành công');
                getDataWarehouses(true);
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
            }
        } catch (error) {
            console.log('error', error);
            setLoading(false);
            message.error('Có lỗi xảy ra, vui lòng thử lại');
        }
    }
    const handleOnSave = async (data) => {
        setShowModal(false);
        if (typeModal === TYPE_MODAL.ADD) {
            callApiAddWarehouse(data);
        } else {
            callApiUpdateProduct(data);
        }
    }

    useEffect(() => {
        setLoading(true);
        Promise.all([getDataBranches(), getDataWarehouses(false)]).finally(() => {
            setLoading(false);
        });
    }, [])

    return (
        <div className='container-content'>

            <Form form={form} name="advanced_search" style={formStyle} onFinish={onFinish}>
                <Row gutter={24}>
                    <Col span={8}>
                        <Form.Item
                            name={'name'}
                        >
                            <Input placeholder={'Nhập tên'} />
                        </Form.Item>
                    </Col>


                    <Col span={4}>
                        <Space size="small">
                            <Button
                                type="primary"
                                htmlType="submit"
                                icon={<SearchOutlined />}
                            >
                                Tìm kiếm
                            </Button>
                            <Button danger
                                onClick={handleAddWarehouse}
                                icon={<PlusOutlined />}
                            >
                                Thêm mới
                            </Button>
                        </Space>
                    </Col>
                </Row>
            </Form>
            <Table
                components={HeaderTableCus}
                columns={columns}
                dataSource={data}
                pagination={false}
                rowKey={(record) => record?.id}
                bordered
                rowClassName={() => 'custom-row'}
            />
            <ModalWarehouseInfo
                visible={showModal}
                onCancel={() => setShowModal(false)}
                data={itemSelected}
                title={titleModal}
                onSave={handleOnSave}
                type={typeModal}
                lstBranches={lstBranches}
            />
            <LoadingBase loading={loading} />
        </div>
    )
}
export default React.memo(ListWarehousePage);